import { render, staticRenderFns } from "./GBrandSettingForm.vue?vue&type=template&id=e4b6208a&scoped=true&"
import script from "./GBrandSettingForm.vue?vue&type=script&lang=ts&"
export * from "./GBrandSettingForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandSettingForm.vue?vue&type=style&index=0&id=e4b6208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b6208a",
  null
  
)

export default component.exports